export default "__VITE_ASSET__BWHcqitH__"